
import React from 'react';
import { Map, MapPin } from 'lucide-react';
import { useLanguage } from '../../contexts/language';
import TotalPledges from './TotalPledges';
import { Region } from '../../data/types/region-types';

interface MapLegendProps {
  regions: Region[];
  selectedRegion: Region | null;
  isGlobalView: boolean;
  isMexicoView: boolean;
}

const MapLegend: React.FC<MapLegendProps> = ({
  regions,
  selectedRegion,
  isGlobalView,
  isMexicoView
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="absolute bottom-24 left-4 space-y-4">
      <div className="bg-white/90 backdrop-blur-sm p-4 rounded-lg shadow-lg z-10 border border-blue-100">
        <h3 className="font-semibold text-sm mb-3 flex items-center text-[#1EAEDB]">
          <Map className="mr-2 h-4 w-4" />
          {t('legend')}
        </h3>
        <div className="space-y-2">
          <div className="flex items-center">
            <div className="w-5 h-5 mr-2 flex-shrink-0 flex items-center justify-center">
              <MapPin className="h-5 w-5" color="#F97316" fill="#F97316" strokeWidth={1.5} />
            </div>
            <span className="text-xs">
              {t('lowChristianPresence')} ({'<'}10%)
            </span>
          </div>
          <div className="flex items-center">
            <div className="w-5 h-5 mr-2 flex-shrink-0 flex items-center justify-center">
              <MapPin className="h-5 w-5" color="#ea384c" fill="#ea384c" strokeWidth={1.5} />
            </div>
            <span className="text-xs">
              {t('veryLowChristianPresence')} ({'<'}5%)
            </span>
          </div>
          <div className="flex items-center">
            <div className="w-5 h-5 mr-2 flex-shrink-0 flex items-center justify-center">
              <MapPin className="h-5 w-5" color="#9b87f5" fill="#9b87f5" strokeWidth={1.5} />
            </div>
            <span className="text-xs">
              {t('areaOfNeed') || 'Area of Need'}
            </span>
          </div>
        </div>
      </div>
      
      <TotalPledges
        regions={regions}
        selectedRegion={selectedRegion}
        isGlobalView={isGlobalView}
        isMexicoView={isMexicoView}
      />
    </div>
  );
};

export default MapLegend;
